// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

.login-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.login-card h2 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #2c3e50;
  text-align: center;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #555;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.form-group input:focus {
  outline: none;
  border-color: #3498db;
}

.error-message {
  background-color: #fee;
  color: #c33;
  padding: 0.75rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  text-align: center;
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  padding: 0.75rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  text-align: center;
}

.toggle-mode {
  margin-top: 1rem;
  text-align: center;
  color: #555;
  font-size: 0.9rem;
}

.link-btn {
  background: none;
  border: none;
  color: #3498db;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-size: inherit;
}

.link-btn:hover {
  color: #2980b9;
}

.btn-primary {
  width: 100%;
  padding: 0.75rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover:not(:disabled) {
  background-color: #2980b9;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 0.5rem 1rem;
  background-color: #95a5a6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-secondary:hover {
  background-color: #7f8c8d;
}

.chat-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
}

.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  background: white;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chat-header h2 {
  margin: 0;
  color: #2c3e50;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .login-container {
    min-height: 50vh;
    padding: 1rem;
  }

  .login-card {
    padding: 1.5rem;
  }

  .chat-page {
    height: calc(100vh - 140px);
  }

  .chat-header {
    flex-direction: column;
    gap: 0.75rem;
    padding: 0.75rem;
  }

  .chat-header h2 {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .login-card {
    padding: 1rem;
  }

  .login-card h2 {
    font-size: 1.2rem;
  }

  .form-group label {
    font-size: 0.9rem;
  }

  .form-group input {
    padding: 0.6rem;
    font-size: 0.9rem;
  }

  .btn-primary {
    padding: 0.6rem;
    font-size: 0.9rem;
  }

  .chat-page {
    height: calc(100vh - 160px);
  }

  .chat-header {
    padding: 0.5rem;
  }

  .chat-header h2 {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ChatPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 60vh;\n}\n\n.login-card {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 400px;\n}\n\n.login-card h2 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  color: #2c3e50;\n  text-align: center;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #555;\n  font-weight: 500;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #3498db;\n}\n\n.error-message {\n  background-color: #fee;\n  color: #c33;\n  padding: 0.75rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.success-message {\n  background-color: #d4edda;\n  color: #155724;\n  padding: 0.75rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.toggle-mode {\n  margin-top: 1rem;\n  text-align: center;\n  color: #555;\n  font-size: 0.9rem;\n}\n\n.link-btn {\n  background: none;\n  border: none;\n  color: #3498db;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n  font-size: inherit;\n}\n\n.link-btn:hover {\n  color: #2980b9;\n}\n\n.btn-primary {\n  width: 100%;\n  padding: 0.75rem;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: #2980b9;\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  padding: 0.5rem 1rem;\n  background-color: #95a5a6;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.btn-secondary:hover {\n  background-color: #7f8c8d;\n}\n\n.chat-page {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 120px);\n}\n\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  background: white;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.chat-header h2 {\n  margin: 0;\n  color: #2c3e50;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .login-container {\n    min-height: 50vh;\n    padding: 1rem;\n  }\n\n  .login-card {\n    padding: 1.5rem;\n  }\n\n  .chat-page {\n    height: calc(100vh - 140px);\n  }\n\n  .chat-header {\n    flex-direction: column;\n    gap: 0.75rem;\n    padding: 0.75rem;\n  }\n\n  .chat-header h2 {\n    font-size: 1.1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-card {\n    padding: 1rem;\n  }\n\n  .login-card h2 {\n    font-size: 1.2rem;\n  }\n\n  .form-group label {\n    font-size: 0.9rem;\n  }\n\n  .form-group input {\n    padding: 0.6rem;\n    font-size: 0.9rem;\n  }\n\n  .btn-primary {\n    padding: 0.6rem;\n    font-size: 0.9rem;\n  }\n\n  .chat-page {\n    height: calc(100vh - 160px);\n  }\n\n  .chat-header {\n    padding: 0.5rem;\n  }\n\n  .chat-header h2 {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
